import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import Text from '~components/atoms/Text';

import PaperSilverPricingTable from './PaperSilverPricingTable';
import PhysicalSilverPricingTable from './PhysicalSilverPricingTable';
import * as Styles from './_dailySilverPrice.module.scss';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import PreciousMetalPricingTable from './SilverProductPricingTable';
import SilverProductPricingTable from './SilverProductPricingTable';

const DailySilverPrice = () => {
    const dispatch = useAppDispatch();
    const silverPrices = useAppSelector((state) => state.silver.buyAndSellSilver.silverPrices);

    const [sbuyPrice, setSbuyPrice] = useState<string>('');
    const [ssellPrice, setSsellPrice] = useState<string>('');

    useEffect(() => {
        // Initial dispatch
        dispatch(combinedActions.silverGetSilverPricesAttempt());
        dispatch(combinedActions.dashboardGetDashboardSilverProductPricingAttempt());

        const intervalId = setInterval(() => {
            dispatch(combinedActions.silverGetSilverPricesAttempt());
            dispatch(combinedActions.dashboardGetDashboardSilverProductPricingAttempt());
        }, 3000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    useEffect(() => {
        setSbuyPrice(silverPrices?.gbuy ?? '');
        setSsellPrice(silverPrices?.gsell ?? '');
    }, [silverPrices]);

    return (
        <div className={Styles.container}>
            <div className={Styles['info-container']}>
                <Text
                    label='DAILY SILVER PRICE'
                    className={Styles.title}
                    isBold
                />

                <Text
                    label={`API Silver Buy Price: ${sbuyPrice || '-'} | API Silver Sell Price: ${ssellPrice || '-'}`}
                    className={Styles['silver-price-text']}
                />

                <Text
                    label={`Updated at ${silverPrices?.validFrom
                        ? dayjs(silverPrices.validFrom).format('DD MMM YYYY HH:mm:ss A')
                        : '-'}`}
                />
            </div>

            <div className={Styles['price-container']}>
                <PhysicalSilverPricingTable />

                <div className={Styles['block-container']}>
                    <PaperSilverPricingTable />
                    <SilverProductPricingTable />
                </div>
            </div>

            <div className={Styles['info-container']}>
                <Text
                    label={'*The above denominations are subject to the Bank\'s discretion from time to time.'}
                />
            </div>
        </div>
    );
};

export default DailySilverPrice;
